import {
    TIMESHEET_HOLIDAY_CREATE_REQUESTED,
    TIMESHEET_HOLIDAY_CREATE_SUCCEEDED,
    TIMESHEET_HOLIDAY_CREATE_FAILED,
    TIMESHEET_HOLIDAY_UPDATE_REQUESTED,
    TIMESHEET_HOLIDAY_UPDATE_SUCCEEDED,
    TIMESHEET_HOLIDAY_UPDATE_FAILED,
    TIMESHEET_HOLIDAYS_SET,
    TIMESHEET_HOLIDAY_SET
} from './constants';
import {
    RequestedCreateTimesheetHolidayActionCreator,
    SuccceededCreateTimesheetHolidayActionCreator,
    FailedCreateTimesheetHolidayActionCreator,
    RequestedUpdateTimesheetHolidayActionCreator,
    SuccceededUpdateTimesheetHolidayActionCreator,
    FailedUpdateTimesheetHolidayActionCreator,
    SetTimesheetHolidaysActionCreator,
    SetTimesheetHolidayActionCreator
} from './types';

export const requestedCreateTimesheetHoliday: RequestedCreateTimesheetHolidayActionCreator = (
    timesheetHoliday
) => {
    return {
        type: TIMESHEET_HOLIDAY_CREATE_REQUESTED,
        payload: timesheetHoliday
    };
};

export const succeededCreateTimesheetHoliday: SuccceededCreateTimesheetHolidayActionCreator = (
    response
) => {
    return {
        type: TIMESHEET_HOLIDAY_CREATE_SUCCEEDED,
        payload: response
    };
};

export const failedCreateTimesheetHoliday: FailedCreateTimesheetHolidayActionCreator = (
    error
) => {
    return {
        type: TIMESHEET_HOLIDAY_CREATE_FAILED,
        payload: error,
        error: true
    };
};

export const requestedUpdateTimesheetHoliday: RequestedUpdateTimesheetHolidayActionCreator = (
    timesheetHolidayId,
    timesheetHoliday
) => {
    return {
        type: TIMESHEET_HOLIDAY_UPDATE_REQUESTED,
        payload: {
            timesheetHolidayId,
            timesheetHoliday
        }
    };
};

export const succeededUpdateTimesheetHoliday: SuccceededUpdateTimesheetHolidayActionCreator = (
    response
) => {
    return {
        type: TIMESHEET_HOLIDAY_UPDATE_SUCCEEDED,
        payload: response
    };
};

export const failedUpdateTimesheetHoliday: FailedUpdateTimesheetHolidayActionCreator = (
    error
) => {
    return {
        type: TIMESHEET_HOLIDAY_UPDATE_FAILED,
        payload: error,
        error: true
    };
};

export const setTimesheetHolidays: SetTimesheetHolidaysActionCreator = (
    timeshetHolidays
) => {
    return {
        type: TIMESHEET_HOLIDAYS_SET,
        payload: timeshetHolidays
    };
};

export const setTimesheetHoliday: SetTimesheetHolidayActionCreator = (
    timesheetHoliday
) => {
    return {
        type: TIMESHEET_HOLIDAY_SET,
        payload: { [timesheetHoliday.uuid]: timesheetHoliday }
    };
};
